<template>
  <roe-error-message v-if="isDeferralRate" :field="tier.deferral_rate">
    <roe-percent-input v-model="tier.$model.deferral_rate"></roe-percent-input>
    <label class="input-label-inside">%</label>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
import RoePercentInput from "@/components/_shared/inputs/PercentInput";
export default {
  name: "RoeTierDeferralRateInput",
  components: { RoePercentInput, RoeErrorMessage },
  props: {
    tier: Object,
    isDeferralRate: Boolean
  }
};
</script>
